export default "__VITE_ASSET__40cd85d3__"